import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NAME_PROJECT } from './enum/constants';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent {
  title = NAME_PROJECT;

  constructor(
    private readonly translate: TranslateService,
    public matIconRegistry: MatIconRegistry,
    public domSanitizer: DomSanitizer,
  ) {
    const svgIconUrl = [
      { name: 'pin', link: 'assets/svgs/icons/pin.svg' },
      { name: 'unpin', link: 'assets/svgs/icons/unpin.svg' },
      { name: 'error', link: 'assets/svgs/icons/error.svg' },
      { name: 'error-outline', link: 'assets/svgs/icons/error-outline.svg' },
      { name: 'file-download', link: 'assets/svgs/icons/file-download.svg' },
      { name: 'file-upload', link: 'assets/svgs/icons/file-upload.svg' },
      { name: 'files', link: 'assets/svgs/icons/files.svg' },
      { name: 'filter', link: 'assets/svgs/icons/filter.svg' },
      { name: 'filter-list', link: 'assets/svgs/icons/filter-list.svg' },
      { name: 'filter-list-off', link: 'assets/svgs/icons/filter-list-off.svg' },
      { name: 'info', link: 'assets/svgs/icons/info.svg' },
      { name: 'info-outline', link: 'assets/svgs/icons/info-outline.svg' },
      { name: 'setting', link: 'assets/svgs/icons/setting.svg' },
      { name: 'success', link: 'assets/svgs/icons/success.svg' },
      { name: 'success-outline', link: 'assets/svgs/icons/success-outline.svg' },
      { name: 'warning', link: 'assets/svgs/icons/warning.svg' },
      { name: 'warning-outline', link: 'assets/svgs/icons/warning-outline.svg' },
      { name: 'crm', link: 'assets/svgs/icons/crm.svg' },
      { name: 'robot', link: 'assets/svgs/icons/robot.svg' },
      { name: 'share', link: 'assets/svgs/icons/share.svg' },
      { name: 'jecrm', link: 'assets/svgs/logos/logo.svg' },
      { name: 'forward', link: 'assets/svgs/icons/forward.svg' },
      { name: 'bot', link: 'assets/svgs/icons/bot.svg' },
      { name: 'bot_fill', link: 'assets/svgs/icons/bot_fill.svg' },
      { name: 'groups_fill', link: 'assets/svgs/icons/groups_fill.svg' },
      { name: 'person_fill', link: 'assets/svgs/icons/person_fill.svg' },
      { name: 'campaign_fill', link: 'assets/svgs/icons/campaign_fill.svg' },
      { name: 'format_quote_fill', link: 'assets/svgs/icons/format_quote_fill.svg' },
      { name: 'ai', link: 'assets/svgs/icons/ai.svg' },
      { name: 'lead', link: 'assets/svgs/icons/lead.svg' },
      { name: 'deal', link: 'assets/svgs/icons/deal.svg' },
      { name: 'integration_instagram', link: 'assets/svgs/integrations/instagram.svg' },
      { name: 'integration_telegram', link: 'assets/svgs/integrations/telegram.svg' },
      { name: 'integration_viber', link: 'assets/svgs/integrations/viber.svg' },
      { name: 'integration_whatsapp', link: 'assets/svgs/integrations/whatsapp.svg' },
      { name: 'integration_tiktok', link: 'assets/svgs/integrations/tiktok.svg' },
    ];
    svgIconUrl.forEach((icon) => {
      const safeSvgIcon = this.domSanitizer.bypassSecurityTrustResourceUrl(icon.link);
      this.matIconRegistry.addSvgIcon(icon.name, safeSvgIcon);
    });
  }
}
